import { api } from '@/api/client';
import type {
  DetailViewsQuota,
  AuthTokenResponse,
  MeResponse,
  RegisterResponse,
  RegistrationAttribution,
} from '@/api/types';

export const authApi = {
  login: (email: string, password: string) =>
    api.post<AuthTokenResponse>('/login', { email, password }),

  register: (
    payload: { name: string; email: string; password: string } & RegistrationAttribution,
  ) => api.post<RegisterResponse>('/register', payload),

  sendVerificationCode: (email: string) =>
    api.post<{ message: string }>('/email-verification/send-code', { email }),

  verifyCode: (email: string, code: string) =>
    api.post<AuthTokenResponse>('/email-verification/verify-code', { email, code }),

  /** Ответ всегда 200 — существование email не раскрывается (AUTH-6). */
  requestPasswordReset: (email: string) =>
    api.post<{ ok: boolean; message: string }>('/auth/password/forgot', { email }),

  /** Второго поля пароля нет: клиент дублирует значение в password_confirmation (AUTH-6). */
  resetPassword: (email: string, code: string, password: string) =>
    api.post<{ ok: boolean; message: string }>('/auth/password/reset', {
      email,
      code,
      password,
      password_confirmation: password,
    }),

  googleSignIn: (idToken: string, attribution: RegistrationAttribution) =>
    api.post<AuthTokenResponse>('/auth/google', { id_token: idToken, ...attribution }),

  logout: () => api.post<{ message: string }>('/logout', {}),

  me: () => api.get<MeResponse>('/me'),

  markWelcomeShown: () => api.post<{ ok: boolean }>('/me/welcome-shown', {}),

  /** B6: пишется и при завершении, и при пропуске гида (ONB-3). */
  completeOnboarding: () =>
    api.post<{ ok: boolean; onboarding_completed_at: string }>('/me/onboarding-complete', {}),

  /** Списать детальный просмотр с дневной квоты бесплатного тарифа; 403 detail_quota_exceeded — лимит. */
  registerDetailView: (videoId: number) =>
    api.post<{ ok: boolean; quota: DetailViewsQuota | null }>('/me/detail-views', {
      video_reference_id: videoId,
    }),
};
